<template minapp='mpx' xlang='wxml'>
  <es-layout
    layout="{{['header', 'footer']}}"
    class="es-selectCountry"
    navbarTitle="选择国家或地区"
    navbarClickLeft="{{goBack}}"
    leftArrow="{{true}}"
    bind:scrolling='handleScroll'
    custom-main="custom-main"
    custom-navbar="custom-navbar"
    scrollTop="{{topHeight}}"
    scrollWithAnimation="{{true}}"
    wx:ref="scroll_layout"
  >
    <!-- 导航栏 -->
    <view class="page-header" slot="header">
      <!-- 搜索 -->
      <search-input bind:input="handleInput" placeholder="中文 / 英文" showFocusBorder="{{true}}"/>
      <view class="es-selectCountry__keyString" wx:if="{{!isSearch&&!isLoading}}">{{copyKeyString}}</view>
      <view class="es-selectCountry__tabView" wx:if="{{!isSearch&&!isLoading}}">
        <view class="es-selectCountry__tab">
          <view wx:for="{{tabData}}" wx:for-item="tabItem"  class="es-selectCountry__tabItem {{copyKeyString == tabItem ? 'es-selectCountry__active' : ''}}" bind:tap="onChange(tabItem)">
              {{tabItem}}
          </view>
        </view>
      </view>
    </view>
    
    <view class="es-selectCountry__list" id="country_list">
      <view wx:for="{{isSearch?searchRes:innnerGoupCountry}}" id="{{'block' + item.keyString}}">
        <view wx:for="{{item.data}}" class="es-selectCountry__list-item" wx:style="{{mright}}" wx:for-item="keyItem" bindtap="selectCountry(keyItem)">
          <view class="es-selectCountry__country_name">
            <view class="es-selectCountry__country_name_cn">{{keyItem.country_name_cn}}</view>
            <view class="es-selectCountry__country_name_en">{{ ' (' + keyItem.country_code + ', ' + keyItem.country_name_en + ')'}}</view>
          </view>
          <view wx:if="{{keyItem.isSelected}}">
            <es-icon name="check-filled" size="{{18}}" color="#1473ff"/>
          </view>
        </view>
      </view>
      <view wx:if="{{ isSearch && !hasRes && !isLoading }}" class="es-selectCountry__noResult">
        <view style="height:180px"></view>
        暂无匹配结果
      </view>
    </view>
    <view class="select_country_footer" wx:if="{{ !(isSearch && !hasRes && !isLoading) }}"></view>
  </es-layout>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { getGroupCountry, getCountry } from '@/api/contact/index'
  import { debounce } from '@/utils'
  import { findIndex } from 'lodash'
  import { innerRouter, pagePath } from "@/common/jump";
  
  import store from '@/store'
  let timer = null
  createPage({
    data: {
      keywords: '',
      keyString: '',
      copyKeyString: 'A',
      isSelectCountry: '爱沙尼亚',
      heightList: [],
      //下发的数据确实几个数据
      innnerGoupCountry:{
        "A":{},"B":{},"C":{},"D":{},"E":{},"F":{},"G":{},"H":{},"I":{},"J":{},
        "K":{},"L":{},"M":{},"N":{},"O":{},"P":{},"Q":{},"R":{},"S":{},"T":{},"U":{},
        "V":{},"W":{},"X":{},"Y":{},"Z":{},
      },
      searchRes:{},
      isLoading:true,
      isSearch:false,
      cardType:-1,
      topHeight:0,
      customMainHeight:580
    },

    computed: {
      ...store.mapState({
        nationality: 'newContacts.nationality',
        groupCountry: 'newContacts.groupCountry'
      }),
      tabData(){
        let keyOfGroupCountry = Object.keys(this.groupCountry)
        //防止后端传递或者Object.keys导致的乱序，需进行排序

        keyOfGroupCountry.sort(function (s1, s2) {
          let a = s1.toUpperCase()
          let b = s2.toUpperCase()
          if (a < b) return -1 
          if (a > b) return 1
          return 0;  
        });
        return keyOfGroupCountry
      },
      mright(){
        return this.isSearch?{
          'margin-right': '12px'
        }:{}
      },
      hasRes(){
        return JSON.stringify(this.searchRes) !== "{}"
      }
    },
    watch: {
      groupCountry(val){
        for (let item in val){
          this.innnerGoupCountry[item] ={ keyString:item, data:val[item]}

          let groupValue = this.innnerGoupCountry[item]?.data 
          //设置选中的国籍
          groupValue?.forEach(element => {
            const { country_code } = this.nationality
            if(element.country_code == country_code){
              element.isSelected = true
            }
          });
        }
      },
      keywords(val){
        this.search(val)
        if(!val){
          this.isSearch = false
          this.searchRes = {}
        }
      }
    },

    methods: {
      ...store.mapMutations({
        setNationality: 'newContacts.setNationality',
      }),
      ...store.mapActions({
        getGroupCountryAction: 'newContacts.getGroupCountryAction',
      }),

      search: debounce(
        async function (params) {
          if(!params||this.isLoading) return
          this.isSearch = true
          this.isLoading = true
          let { data: { country_list }, success, code, message } = await getGroupCountry({ keyword: params })
          if(success){
            if(code == 0){
              if (!country_list) return
              let tempObj = {}
              for (let item in country_list){
                tempObj[item] ={ keyString: item, data: country_list[item]}
              }
              this.searchRes = tempObj
              this.$forceUpdate()
            }else{
              this.searchRes = {}
            }
          }else{
            mpx.showToast({
              title: LOAD_FAIL_CONTENT,
              icon: 'error',
            })
          }
          this.isLoading = false
        },
        500,
        false
      ),


      goBack() {
        innerRouter.goback()
      },

      handleInput(e) {
        this.keywords = e.detail;
      },

      selectCountry(item){
        this.setNationality({
          country_code:item.canonical_country_code,
          country_name_cn:item.country_name_cn
        })
        setTimeout(() => {
          this.goBack()
        }, 500);
      },
      onChange(e) {
        const index = findIndex(this.tabData, item => {
          return e == item
        });
        let oldTopHeight = this.topHeight
        if(index === 0){
          this.topHeight = 0
          this.keyString = e
          this.copyKeyString = e
        }else if(index > this.tabData.length-2){
          this.topHeight = this.heightList[this.tabData.length-1] - this.customMainHeight + 40
          setTimeout(() => {
            this.keyString = e
            this.copyKeyString = e
          }, 450);
        }else{
          this.topHeight = this.heightList[index - 1]
          this.keyString = e
          this.copyKeyString = e
        }
        //防止每次一样时，没有触发视图刷次
        if(oldTopHeight === this.topHeight){
          let isAdd = Math.random() > 0.5? 1:-1
          this.topHeight = this.topHeight + isAdd
        }
        
        this.$forceUpdate()
      },
      // 获取当前的元素节点
      getElement (ele, cb) {
        const query = mpx.createSelectorQuery().in(this)
        query
          .select(ele)
          .boundingClientRect(cb).exec()
      },
      // 获取元素高度，
      getElementHeight () {      
        this.heightList = []
        let idList = []
        for (let item in this.innnerGoupCountry){
          if(this.innnerGoupCountry[item]?.keyString){
            idList.push('block' + item)
          }
        }
        let callback = (rect) => {
          const { height } = rect || {}
          let addHeight = (height || 0) 
          let preHeight = this.heightList.length > 0 ? this.heightList[this.heightList.length-1] : 0
          this.heightList.push(addHeight + preHeight)
        }
        idList?.forEach(id => {
          this.getElement(`#${id}`, callback)
        })

        //获取国家的长度
        let getCustomMainHeight = __mpx_mode__==='web'?this.$refs?.__mpx_ref_scroll_layout__?.getCustomMainHeight : this.$refs?.scroll_layout?.getCustomMainHeight
        //兼容写法，万一都取之不到的情况
        if(getCustomMainHeight){
          this.customMainHeight = getCustomMainHeight()
        }else{
          this.customMainHeight = 540
        }
      },
      handleScroll({ detail }) {
        const { scrollTop } = detail.detail
        let findIndex = 0
        this.heightList.find((item, index) => {
          findIndex = index
          return item > scrollTop
        })
        this.copyKeyString = this.tabData[findIndex]
      }
    },

    mounted() {
      mpx.setNavigationBarColor({ frontColor: '#000000' })
      const {
        cardType
      } = this.$mpxRoute.query

      this.cardType = cardType

      this.getGroupCountryAction().then(()=>{
        this.isLoading = false
        setTimeout(() => {
          this.getElementHeight()
        }, 500);
      })
    },
  })
</script>

<style lang='stylus' scoped>
  +b('selectCountry')
    +e('keyString')
      display flex
      align-items center
      padding-left 12px
      height 30px
      background-color #F3F4F5
      color #333333
      font-size 14px
    +e('list')
      background-color #FFFFFF
      // width 100%
      // height 100%
    +e('list-item')
      display flex
      justify-content space-between
      position relative
      align-items center
      margin 0 36px 0 12px
      padding-right 5px
      height 44px
      background #FFFFFF
      &::after
          content " "
          position absolute
          left 0
          bottom 0
          width 100%
          height 1px
          background #eeeeee
          transform scaleY(0.5)

    +e('tabView')
      position fixed 
      z-index 1
      height calc(100% - 156px)
      right 0px
      overflow scroll
    +e('tab')
      font-size 12px
      min-height 416px
      background: #FFFFFF
      padding-top 12px
      color #999999
      text-align center
    +e('tabItem')
      line-height 16px
      padding 0 12px
    +e('active')
      color #1473ff
    +e('noResult')
      font-family PingFangSC-Regular
      font-size 14px
      color #999999
      background #ffffff
      text-align center
      // padding-top 180px
    +e('country_name')
      display flex
      align-items center
      flex-wrap wrap
    +e('country_name_cn')
      font-size 14px
    +e('country_name_en')
      font-size 12px
    
    
  .custom-main
    background: #FFFFFF !important
  /deep/ .custom-main
    background: #ffffff !important
  .custom-navbar
    background: #FFFFFF !important
  /deep/ .custom-navbar
    background: #ffffff !important
  .select_country_footer
    background: #ffffff
    height 44px
    width 100%

</style>

<script name='json'>
  module.exports = {
    // "navigationBarTitleText": "新增出行人信息",
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon/index',
      "search-input": "./components/search-input",
    },
  }
</script>

